export class RecuperarContrasenaI{
  user : String;
}
